<template>
    <v-card style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Copy Access Permission Template</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
            Error encountered. Please contact support. Error details: {{errorMessage}}
        </v-alert> 
        <v-card-text>
            <v-layout row wrap> 
                <v-flex xs12 sm12 style="padding: 0px 15px 0px 15px; ">
                    <v-text-field v-model="search" append-icon="search" style="margin-top:-10px;" label="Search template name" single-line hide-details></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap> 
                <v-flex xs12 sm12>
                    <v-data-table
                        :headers="header"
                        :items="templates_filtered"
                        :hide-actions="templates_filtered.length<4"
                        :rows-per-page-items="[3]"
                    >
                        <template v-slot:items="props">
                            <tr style="cursor:pointer;" title="Click to copy" @click="selectTemplate(props.item)"> 
                                <td>{{props.item.templateName}}</td>
                                <td>{{props.item.createdByName}}</td>
                                <td>{{props.item.createdOn | moment('MMM DD, YYYY')}}</td>
                            </tr>
                        </template>
                    </v-data-table>    
                </v-flex>
            </v-layout>
            <v-layout row wrap> 
                <v-flex xs12 sm12 style="padding: 0px 15px 0px 15px; ">
                    <v-alert v-if="selected!=null" :value="true" color="warning" icon="warning" outline >
                        Apply <b>{{selected.templateName}}</b> template to the selected user?                        
                    </v-alert>  
                </v-flex>
                <v-flex v-if="selected!=null" xs12 sm12 style="padding: 0px 15px 0px 15px; ">
                     <v-card-actions height="45px">
                        <v-spacer></v-spacer>
                        <v-btn color="warning" :loading="loading" @click="copyTemplate" style="color:white;margin-right:-10px;">Proceed</v-btn>
                    </v-card-actions>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>

import appsApi from '@/api/applications'

export default {
    data () {
        return {
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            header: [
                {text: 'Template name',align: 'left',value: '',width: '40%', sortable:false},
                {text: 'Created By',align: 'left',value: '',width: '40%', sortable:false},
                {text: 'Created On',align: 'left',value: '',width: '20%', sortable:false},
            ],
            search: null,
            selected: null,
            templates: [],
            userId: null,
            templateName: null
        }   
    },
    methods: {
        async copyTemplate() {
            try{
                this.loading = true
                var data = {
                    userId: this.userId,
                    accessRightsTemplateId: this.selected.accessRightsTemplateId,
                    templateName: this.selected.templateName
                }
                const response = await appsApi.copyTemplate(data)
                if (response && response.status==200) {
                    this.$emit('send', null)
                    this.$emit('update:dialog_copy', false)
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        selectTemplate(data) {
            this.selected = data
        },
        async loadTemplates(userId) {
            try{
                this.search = null
                this.selected = null
                this.userId = userId
                await this.getTemplates()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTemplates() {
            try{
                this.loading = true
                const response = await appsApi.getTemplates()
                if (response && response.status==200) {
                    this.templates = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialog_copy', false)
        },
    },
    created() {},
    computed: {
        templates_filtered() {
            if (this.search) {
                return this.templates.filter(item => {            
                    return item.templateName.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return this.templates
            
        }
    }
}
</script>